import { render, staticRenderFns } from "./DetailsComponent.vue?vue&type=template&id=52c6134e&scoped=true&"
import script from "./DetailsComponent.vue?vue&type=script&lang=js&"
export * from "./DetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailsComponent.vue?vue&type=style&index=0&id=52c6134e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c6134e",
  null
  
)

export default component.exports